module.exports = __webpack_public_path__ + "static/img/watchcarelist.a73954b6.png";